import React from 'react';

function NavbarDisziplin({onLogin, handleDisziplinClick, disziplinList, selectedDisziplin}) {
    return (
        <nav className="navbardisziplin">
            {disziplinList.map((disziplin) => (
                <button key={disziplin.code} 
                        onClick={() => handleDisziplinClick(disziplin.code)}
                        className={disziplin === selectedDisziplin ? 'active' : ''}>
                    {disziplin.name}
                </button>
            ))}
        </nav>
    );
}

export default NavbarDisziplin;
